import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { DetailAdvPage, AdvEmployeePage } from '../';
import { User, Master } from '@providers/advance_providers';
import { ListEmployeePage } from '../list_employee/page';

@Component({
  selector: 'page-organization',
  templateUrl: 'page.html'
})
export class OrganizationPage {

  user:any={};
  akses:any={};
  list:any=[];
  list_unit_path:any=[];
  employee:any=[];
  panelSearch = false;
  organization : any=[];
  selected_organization : any;
  user_organization : any=[];

  loading : any;

  keyword='';
  currentPage = 1;
  pageSize = 50;
  total_rows = 0;
  total_page = 0;

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public userApi: User,
    public loadingCtrl: LoadingController,
    public toastCtrl : ToastController,
    public navParams: NavParams,
    public alertCtrl: AlertController
    ) {
    
    this.user = this.userApi.data;
    this.akses = this.userApi.akses;
  }

  ionViewDidEnter(){
    this.getUserOrganization();
  }

  doRefresh(refresher){
    refresher.complete();
    this.getBusinessOrganization();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content : 'Please wait ...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message : msg,
      duration: 1000,
      position: 'top'
    }).present();
  }
  

  getEmployee(){
    this.showLoading();
    let params : any = {}
    if(this.akses.lihat_advance_employee_group_data=='mine'){
      params.hrm_employee_id = this.user.employee_id,
      params.unit_path_id    = this.user.unit_path_id,
      params.unit_path_id2   = this.user.unit_path_id2
    }
    if(this.keyword!=undefined){
      params.keyword = this.keyword;
    }
    this.masterApi.getEmployee(params).subscribe((resp:any) => {
      this.employee = resp.data;
      console.log("data employee = ",resp.data);
      this.loading.dismiss();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  getBusinessOrganization(){
    this.showLoading();

    let params : any = {}
    if(this.selected_organization == undefined || this.selected_organization == ''){
      
    }else{
        params.parent_id = this.selected_organization.organization_id;
    }
    this.masterApi.getOrganization(params).subscribe((resp:any) => {
      this.organization = resp.data;
      this.loading.dismiss();
    });
    console.log('selected organization => ', this.selected_organization);
  }

  getUserOrganization(){
    let params : any = {employee_id : this.user.employee_id}
    this.masterApi.getOrganization(params).subscribe((resp:any) => {
      this.user_organization = resp.data;
    });

    console.log('selected organization => ', this.selected_organization);
  }

  getPath(unit_path_id){
    let loading = this.loadingCtrl.create({
      content : 'Please wait...'
    });
    loading.present();

    let params : any={ };
    if(unit_path_id != undefined){
      params.unit_path = unit_path_id
    }

    this.masterApi.getOrganization(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.list_unit_path = resp.data;
      }else{

      }
      loading.dismiss();
    },(err) => {
      loading.dismiss();
    });
    
    console.log('path => ', this.list_unit_path);
  }

  toDetailAdvance(id, item){
    this.navCtrl.push(DetailAdvPage, {
      id:id,
      item:item
    });
  }

  getAdvEmployee(employee_id, name){
    this.navCtrl.push(AdvEmployeePage, {
      employee_id:employee_id,
      employee_name: name
    });
  }

  getSub(item,e){
    if(item.subs==0){
      this.presentToast("Sub tidak ditemukan !");
      return;
    }

    // this.getPath(item.location_path_id);
    this.selected_organization = item;
    // this.getList();

    this.getBusinessOrganization();
    this.getPath(item.unit_path_id);
    
    console.log("list path => ", this.list_unit_path);
  }

  selectPath(path){
    this.getPath(path.unit_path_id);
    this.selected_organization = path;
    this.getBusinessOrganization();
  }

  getDetail(item){
    this.navCtrl.push(ListEmployeePage, {
      organization : item
    });
  }

  toParent(){
    this.selected_organization = undefined;
    this.getBusinessOrganization();
    this.getUserOrganization();
  }

  localFormating(v){
    v = parseFloat(v);
    v = v.toLocaleString(['ban', 'id']);
    if(v=='NaN'){
      v='-';
    }
    return v;
  }

  showSearch(){
    this.panelSearch = true;
  }
  hideSearch(){
    this.panelSearch = false;
  }

  onInput(e){
    this.currentPage = 1;
    this.pageSize = 50;
    this.total_rows = 0;
    this.total_page = 0;
    this.getEmployee();
  }

  onCancel(e){
    this.currentPage = 1;
    this.pageSize = 50;
    this.total_rows = 0;
    this.total_page = 0;
    this.getEmployee();
  }



}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/organization/page.ts